import Loader from '@components/Loader/Loader';
import { AnimatePresence, motion } from 'motion/react';
import type { FC } from 'react';

import styles from './EmailSignatureLoadingVeneer.module.scss';

const EmailSignatureLoadingVeneer: FC<React.PropsWithChildren<{ isVisible: boolean }>> = ({ isVisible }) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 1.2,
            ease: 'easeInOut',
            when: 'beforeChildren',
          }}
          className={styles['email-signature-loading-veneer-container']}
        >
          <div className={styles['email-signature-loading-veneer']}>
            <div className={styles['email-signature-loading-dots-wrapper']}>
              <span className={styles['email-signature-loading-text']}>
                We are loading your Blinq email signature
              </span>
              <Loader />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default EmailSignatureLoadingVeneer;
